import { render, staticRenderFns } from "./bodyEditor.vue?vue&type=template&id=058fc4f7&scoped=true&"
import script from "./bodyEditor.vue?vue&type=script&lang=js&"
export * from "./bodyEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058fc4f7",
  null
  
)

export default component.exports